import React, { Component } from 'react';

import './css/ClosedQuestion.css';
import ArrayUtils from "../../utils/ArrayUtils";
import StringUtils from "../../utils/StringUtils";

class ClosedQuestion extends Component {

    componentWillMount() {
        this.selectedCheckboxes = new Set();
        this.selectedRadio = '';

        const answers = this.props.answers;
        // if (this.props.shuffle) {
        //     ArrayUtils.shuffle(answers);
        // }

        const question = StringUtils.parse(this.props.question);

        this.setState({ answers: answers, question: question });
    }

    setScore = (event) => {
        let score = Number.parseInt(event.target.value);
        if (score < 0) score = 0;
        if (score > 1) score = 1;
        this.props.setScore(this.props.id, score);
    };

    render() {
        let i = 1;
        const type = this.props.multipleChoice ? "checkbox" : "radio";
        const containerClass = type + "-container";
        const userAnswer = this.props.userAnswer;
        const isMultipleChoice = this.props.multipleChoice;
        const correctAnswer = this.props.correctAnswer;

        const answers = this.state.answers.map(answer => {
            const answerKey = "answer-" + this.props.number + "-" + i;
            i += 1;
            const checked = userAnswer === answer || (isMultipleChoice && userAnswer.includes(answer));
            let additionalClass = '';
            if (checked) {
                additionalClass = ' user-answer ';
                if (answer === correctAnswer || (isMultipleChoice && correctAnswer.includes(answer))) {
                    additionalClass += ' correct-answer';
                } else {
                    additionalClass += ' wrong-answer'
                }
            }
            return (
                <label key={answerKey} className={"answer " + containerClass + " " + additionalClass}>
                    <input type={type}
                           name={"answer-" + this.props.number}
                           id={answerKey}
                           checked={checked}
                           value={answer}
                           disabled={true}
                    />
                    <span className="checkmark" />
                    <label htmlFor={answerKey}>{StringUtils.parse(answer)}</label>
                </label>);
            }
        );

        let max = 1;
        if (isMultipleChoice) {
            max = correctAnswer.length;
        }

        return (
            <div className="task-block closed-question-check">
                <div className="question-number">Pytanie {this.props.number} (<input type="number" className="score-picker" value={this.props.score} min={0} max={this.props.points} onChange={this.setScore} /> / {max})</div>
                <div className="question">{this.state.question}</div>
                <fieldset id={"group-" + this.props.questionNumber}>
                    {answers}
                </fieldset>
            </div>
        );
    }
}

export default ClosedQuestion;